(function() {
'use strict';

angular
    .module('TR')
    .controller('Options', Options);

function Options($anchorScroll,
                 $location,
                 $q,
                 $rootScope,
                 $routeParams,
                 $scope,
                 $timeout,
                 analytics,
                 arrayUtil,
                 guidService,
                 baggageService,
                 basketService,
                 basketStore,
                 broker,
                 businessFarePopupService,
                 crossSellService,
                 enumService,
                 flightSearch,
                 hotelFromSession,
                 marhabaSearch,
                 marhabaService,
                 occupancyService,
                 optionsUtil,
                 resourceService,
                 scrollService,
                 searchUnitService,
                 tripService,
                 priorityBoardingService,
                 cookieService,
                 flightDetail,
                 mandatoryTransferService) {
    const cm = this;
    const { tripId } = $routeParams;
    const OPTION_TRANSFER = 'transfer';
    const OPTION_PARKING = 'parking';

    let submitted = false;
    let optionsQueue = $q.when();

    cm.additionalInformation = [];
    cm.confirmedBaggageWarning = false;
    cm.loading = true;
    cm.loadingMarhaba = false;
    cm.agentReadConfirm = false;
    cm.showHandLuggageInfo = false;
    cm.skipBaggageCheck = false;
    cm.expandSummary = false;
    cm.allBaggageSelected = true;
    cm.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
    cm.carHireTemporaryDisabled = false;
    cm.isTransferMandatory = false;
    cm.isAvailableTransfer = true;
    cm.isHotelFirstJourney = basketService.isFlightPreselected();
    cm.discount = 0;
    cm.showMobileSearch = TRPCONFIG.DeviceCategory === 'Phone';
    cm.showCancellationsPopUp = false;

    scrollTo(0, 0);
    $rootScope.lockScreen($scope, {
        title: resourceService.get('PREPARINGBOOKING'),
        loadingScreenStyle: 'booking-optionsCtrl'
    });

    function changeWorkflowState(breadcrumb) {
        basketService.changeJourneyUrl(breadcrumb);
    }

    function _getHotelFromSession(trip, hotelFromBasket, routeParams) {
        return hotelFromSession.getHotel(trip.HotelsRequest.AvailabilitySearchId, hotelFromBasket.Details.Id, routeParams.tripId);
    }

    $scope.$on('sendTransferSelection', function(e, val) {
        if (val) {
            $scope.$emit('flash:hide', resourceService.get('BREADCRUMBTRANSFER'));
        }
        cm.selectedTransfer = val;
    });

    $scope.$on('sendParkingSelection', function(e, val) {
        if (val) {
            $scope.$emit('flash:hide', resourceService.get('BREADCRUMBPARKING'));
        }
        cm.selectedParking = val;
    });


    if (TRPCONFIG.Domain.HideOptionPageFooter === true) {
        broker.publish('hideFooter');
    }

    if (TRPCONFIG.Domain.SkipBaggageCheck === true) {
        cm.skipBaggageCheck = true; //skip the baggage check
    }

    tripService.getTrip(tripId).then(trip => {
        const { BasketId, TripId, TripType } = trip;
        const { productId } = $routeParams;
        const isHotelType = TripType === tripService.tripTypes.Hotel;
        const isHolidayType = TripType === tripService.tripTypes.Holiday;
        const isFlightType = TripType === tripService.tripTypes.Flight;

        cm.tripId = TripId;
        cm.tripType = TripType;
        cm.changeWorkflowState = changeWorkflowState;
        cm.attractionsExtraEnabled = (!!TRPCONFIG.Domain.AttractionsExtraEnabled || !!TRPCONFIG.Domain.AttractionsExtraMobileEnabled) && (isHolidayType || isFlightType);
        cm.isKidsFree = trip.IsKidsFree &&
            (parseInt(cookieService.get('KidsPromoAB')) === 1 || TRPCONFIG.Domain.isAgentMode);

        if (trip.FlightsRequest && trip.FlightsRequest.SelectedFlight && trip.FlightsRequest.SelectedFlight.Unavailable) {
            return;
        }

        if (TRPCONFIG.Domain.HoldBaggageEnabled) {
            _updateBagInfo(trip);
        }

        let marhabaSearchId = trip.MarhabaRequest ? trip.MarhabaRequest.AvailabilitySearchId : null;

        cm.oneWayOnly = searchUnitService.isOneWayFlightEnabled();

        cm.businessSpecialFareConfirmationPopup = function() {
            const businessSpecialFare = resourceService.get('BUSINESSSPECIALFARE');
            const businessSpecialFareMessage = resourceService.get('BUSINESSSPECIALFAREMESSAGE');
            return businessFarePopupService.showPopup({
                popupHeader: resourceService.get('TERMSANDCONDITIONS'),
                popupMessage: `<h6><strong>${businessSpecialFare}</strong></h6><br><p>${businessSpecialFareMessage}</p><br>`,
                readTermsText: resourceService.get('BUSINESSSPECIALFARETERMS'),
                continueButtonLabel: resourceService.get('CONTINUETONEXTSTEP'),
                returnButtonLabel: resourceService.get('CALENDAR_RETURN')
            });
        };

        cm.book = function() {
            let businessSpecialPopup = false;
            if (cm.flight && cm.flight.Details.Itinerary.Legs.length) {
                cm.flight.Details.Itinerary.Legs.forEach(leg => {
                    if (leg.Segments.length) {
                          leg.Segments.some(segment => {
                            if (segment.SupplierFareClass === 'H' && (segment.CarrierCode === 'EK' || segment.CodeshareAirlineName === 'Emirates')) {
                                businessSpecialPopup = true;
                                return true;
                            }
                            return false;
                        });
                    }
                });
            }
            if (businessSpecialPopup) {
                return cm.businessSpecialFareConfirmationPopup()
                    .then(() => {
                        cm.continueToBook();
                    });
            }
            cm.continueToBook();
        };

        cm.continueToBook = function() {
            if (cm.hotel) {
                const validOptionsSelected = checkOptions([OPTION_TRANSFER, OPTION_PARKING]);

                if (validOptionsSelected.errors.length > 0) {
                    $scope.$emit('flash:error', resourceService.get(`BREADCRUMB${validOptionsSelected.errors[0].title.toUpperCase()}`));
                    scrollService.scrollTo(`#${validOptionsSelected.errors[0].id}`, { offset: validOptionsSelected.errors[0].offset });
                    return;
                }
                if (cm.disableWithAgentControl() || (cm.isTransferMandatory && !cm.isAvailableTransfer)) {
                    return;
                }
                try {
                    const sum = array => _(array).map(x => x.Quantity * x.UnitAmount).reduce((memo, num) => memo + num, 0);
                    const insurance = _.filter(cm.costBreakdown, c => c.Description.indexOf('Travel Insurance') > -1);
                    const marhaba = _.filter(cm.costBreakdown, c => c.Description.indexOf('Meet and Greet') > -1 || c.Description.indexOf('Marhaba') > -1);
                    analytics.track('Event', 'OptionsPageClick', {
                        Revenue: cm.totalCost,
                        Insurance: sum(insurance),
                        Marhaba: sum(marhaba)
                    });
                } catch (err) {}
                if (TRPCONFIG.DeviceSettings.UseBaggageWarningPopup && !cm.confirmedBaggageWarning && !cm.bagsSelected && !cm.bagsIncluded && !cm.skipBaggageCheck) {
                    cm.showPopupBaggage = true;
                    return;
                }
                submitted = true;
                basketService.bookBasket(TripId, BasketId);
            } else {
                window.location.replace(`holidays/hotels/${tripId}`);
            }
        };

        broker.subscribe('Options', 'basketUpdated', function() {
            _updateCostBreakdown(BasketId)();
            if (TRPCONFIG.Domain.HoldBaggageEnabled) {
                _updateBagInfo(trip);
            }
            _updateDepositValues(BasketId);
        });

        $scope.$on('$destroy', () => {
            broker.unsubscribe('Options');
        });

        $q.all([
            basketStore.all(BasketId, productId),
            basketStore.costBreakdown(BasketId, productId),
            basketStore.flightOptions(BasketId, productId),
            basketStore.rules(BasketId, productId),
            basketStore.totalDeposit(BasketId, productId),
            basketStore.balancesDue(BasketId, productId),
            basketStore.optionConditions(BasketId),
            basketStore.totalCost(BasketId),
            basketStore.flightBaggageCostings(BasketId),
            basketStore.payDirectTotal(BasketId),
            basketStore.payments(BasketId),
            tripService.getTripReducedOccupancy(TripId)
        ]).then(function(results) {
            cm.products = results[0];
            const hotel = results[0].h;
            const flight = results[0].f;
            const transfer = results[0].t;

            cm.occupancy = results[11];
            cm.children = (cm.occupancy.ChildAges && cm.occupancy.ChildAges.length) || 0;

            if (hotel != null) {
                _getHotelFromSession(trip, hotel, $routeParams).then(function() {
                    if (Object.keys(hotel && hotel.Details)) {
                        cm.roomsWithMandatoryTransfer = mandatoryTransferService
                                                            .getHolidayRoomsWithTransfers(hotel.Details || []);
                    }
                });
            }

            async function setAvailableTransfer() {
                const roomsWithMandatoryTransfer = await mandatoryTransferService
                .getHolidayRoomsWithTransfers(hotel.Details || []);
                const mandatoryTransfers = _.get(roomsWithMandatoryTransfer, 'mandatoryTransfers');
                if (mandatoryTransfers) {
                    cm.isAvailableTransfer = true;
                }
            }

            if (hotel != null) {
                setAvailableTransfer();
            }

            $rootScope.unlockScreen($scope);
            if (flight == null) {
                return;
            }

            cm.flight = flight;
            cm.hotel = hotel;
            if (TRPCONFIG.Domain.HideOptionPageAgentCheckboxWhenNoInfomation && !hotel) {
                cm.agentReadConfirm = true;
            }
            cm.transfer = transfer;
            cm.costBreakdown = results[1];
            cm.marhabaEnabled = TRPCONFIG.Domain.MarhabaEnabled;
            cm.optionConditions = results[6];
            cm.totalCost = results[7];
            cm.payDirectAmount = results[9];
            cm.paymentData = results[10];
            cm.marhaba = results[0].m;
            cm.isPackage = _.get(flight, 'PackageId') || _.get(hotel, 'PackageId');

            const flightAddInfo = JSON.parse(sessionStorage.getItem('flightAddInfo'));
            if (!flightAddInfo || flightAddInfo.default.searchId !== cm.flight.AvailabilitySearchId) {
                let data = {
                    default: {
                        searchId: cm.flight.AvailabilitySearchId,
                        addtionalInfo: cm.flight.Details.AdditionalInformation
                    }
                };
                sessionStorage.setItem('flightAddInfo', JSON.stringify(data));
            }

            analytics.track('Event', 'OptionsPage', {
                TotalCost: cm.totalCost,
                Hotel: cm.hotel,
                Flight: cm.flight
            });

            analytics.track('Facebook', 'OptionsPage');

            const flightOptions = results[2];
            cm.priorityBoarding = priorityBoardingService.getPriorityBoardingInfo(flight, flightOptions);
            cm.selectedFlightSector = arrayUtil.map(flight.Details.FlightSectorOptionalExtras, sector => optionsUtil.parseSelectedOptions(sector, flightOptions));

            angular.forEach(cm.flight.Details.FlightSectorOptionalExtras, function(sector, sectorIndex) {
                const selected = cm.selectedFlightSector[sectorIndex];
                angular.forEach(sector.OptionalExtras, function(extras, parentIndex) {
                    angular.forEach(extras.MultiOptionalExtras, function(extra, index) {
                        _setQuantitative(extra, parentIndex, index, selected);
                    });
                });
            });

            cm.basketRules = results[3];
            cm.totalDeposit = results[4];

            cm.costBreakdown.forEach(breakdown => { // Where id 20 is discount
                cm.discount += breakdown.TypeId === 20 ? (breakdown.UnitAmount * breakdown.Quantity) : 0;
            });

            // Sum invisible price with hotel
            cm.costBreakdown = cm.costBreakdown.map(breakdown => {
                breakdown.TotalPrice = 0;
                if (breakdown.TypeId === 1) { // Where id 1 is id of the hotel
                    breakdown.TotalPrice = (breakdown.UnitAmount * breakdown.Quantity);
                    cm.costBreakdown.forEach(invisible => {
                        // Where id 0 is id of the invisible price
                        if (invisible.TypeId === 0 && invisible.IsPriceHidden) {
                            breakdown.TotalPrice += invisible.UnitAmount;
                        }
                    });
                }

                return breakdown;
            });

            if ((isHotelType || isHolidayType) && hotel && hotel.Details) {
                tripService.getDurationSummary(searchUnitService.hotel, $routeParams.tripId).then(ds => cm.durationSummary = ds);
                cm.additionalInformation = hotel.Details.AdditionalInformation.concat(hotel.Details.PromotionalInformation);
            }

            if (TRPCONFIG.Domain.IsCarHireTemporaryDisabled) {
                isCarHireTemporaryDisabled();
            }

            cm.loading = false;

            cm.getFlightInfo = function() {
                return flightSearch.getFlightInfo(cm.flight.Details.Itinerary);
            };

            cm.getBaggageAllowanceTotalKg = function() {
                return flightSearch.getBaggageAllowanceTotalKg(cm.flight.Details.Itinerary);
            };

            cm.getBaggagePieces = function() {
                return flightSearch.getBaggagePieces(cm.flight.Details.Itinerary);
            };

            cm.getBaggageAllowanceKgPerBag = function() {
                return flightSearch.getBaggageAllowanceKgPerBag(cm.flight.Details.Itinerary);
            };

            cm.cabinType = (cm.flight && cm.flight.Details.Itinerary.Legs[0]) ? cm.flight.Details.Itinerary.Legs[0].CabinType : null;

            broker.subscribe('optionsCtrl', 'updateBrandedFareFlight', e => {
                cm.cabinType = e.data[0].CabinType;
            });

            cm.transferType = function() {
                let trans = JSON.parse(sessionStorage.getItem('Transfer'));
                let finalTransfer;
                if (trans && trans.Title) {
                    finalTransfer = trans.Title;
                } else if (trans && trans.Type) {
                    finalTransfer = trans.Type;
                } else {
                    finalTransfer = cm.transfer ? cm.transfer.Details.Itinerary.InboundLeg.TransferType : '';
                }
                if (!cm.showCancellationsPopUp) {
                    if (TRPCONFIG.Domain.BrandedFareCancellations || sessionStorage.getItem('BrandedFareCancellations') !== null) {
                        cm.showCancellationsPopUp = true;
                    }
                }
                if (!finalTransfer) {
                    const transfer = JSON.parse(sessionStorage.getItem('IncludedExtras'));
                    finalTransfer = transfer && transfer.Title ? transfer.Title : '';
                }
                return finalTransfer;
            };

            cm.showCancellationsDetails = function() {
                return flightSearch.showCancellationsDetailsModal();
            };

            function updateFlightOptionsInBasket(storeFn) {
                return function(options) {
                    return storeFn.call(basketStore, basketStore.productType.Flight, flight.ProductId, options, BasketId);
                };
            }

            function addOrRemoveFlightOptionsFromBasket() {
                optionsQueue = optionsQueue.then(function() {
                    return basketStore.flightOptions(BasketId).then(function(bo) {
                        //we have to filter out checkin option from the flight options because everything is awful.
                        bo = arrayUtil.filter(bo, function(o) {
                            return !optionsUtil.isCheckInOption(flight.Details.FlightSectorOptionalExtras, o);
                        });

                        const so = _mergeSelectedOptions();
                        //we need to wait for all removes to return until we do the adds otherwise things
                        //get out of sync with the basket

                        return _missingFrom(bo, so, updateFlightOptionsInBasket(basketStore.removeOptions)).then(function() {
                            return _missingFrom(so, bo, updateFlightOptionsInBasket(basketStore.addOptions));
                        }).then(_updateBasket);
                    });
                });
            }

            cm.removeMarhaba = function() {
                basketStore.removeMarhaba(BasketId).then(function() {
                    _updateBasket();
                });
            };

            if (cm.marhabaEnabled) {
                _buildMarhabaOptions(flight);
            }

            cm.getSecondaryMarhabaOptions = function(option) {
                const params = {
                    Terminal: { Id: option.TerminalId, Name: option.Terminal },
                    FlightType: option.FlightType,
                    Airport: option.Airport,
                    DateAndTime: option.Date,
                    Occupancy: { Adults: cm.occupancy.Adults, Children: cm.children, Infants: 0 }
                };

                if (!marhabaSearchId) {
                    marhabaSearchId = guidService.uuid();
                }

                return marhabaSearch.search({ searchId: marhabaSearchId, tripId: TripId, newSearch: true, parameters: params })
                    .then(function(res) {
                        return res;
                    });
            };

            cm.addMarhabaToBasket = function() {
                cm.noOfPassengers = occupancyService.getNumberOfNonInfantPassengers();
                cm.selection = { auxillaries: {} };

                // Products are split between chauffeurs and auxiliaries
                cm.auxillaryProducts = [];
                cm.chauffeurs = [];
                cm.lounges = [];

                return basketStore.addMarhaba(marhabaSearchId, cm.selectedSecondayMarhabaOption.Id, BasketId)
                    .then(function(productInfo) {
                        cm.additionalMarhabaOptions = productInfo.Details.AvailableOptions;

                        const res = marhabaService.adjustMarhabaOptions(productInfo, resourceService.get('SELECTCHAUFFEUR'));

                        if (res.noOptions) {
                            cm.noOptions = res.noOptions;
                        } else {
                            cm.auxillaryProducts = res.auxillaryProducts;
                            cm.chauffeurs = res.chauffeurs;
                            cm.lounges = res.lounges;
                            cm.selection.chauffeur = res.selectedChauffeur;
                        }
                        cm.loaded = true;
                        cm.loadingMarhaba = false;

                        _updateBasket();

                        return productInfo;
                    });
            };

            cm.confirmMarhaba = function() {
                // The chauffeurs is treated as any other auxillaries
                if (cm.selection.chauffeur && cm.selection.chauffeur.Id !== 0) {
                    cm.selection.auxillaries[cm.selection.chauffeur.Id] = cm.selection.chauffeur.Num;
                }

                // Lounges is treated as any other auxillaries
                _.forEach(cm.lounges, function(lo) {
                    //Remove all other Lounges
                    cm.selection.auxillaries[lo.Id] = 0;
                });
                // Only one Lounge can be added
                if (cm.selection.lounge) {
                    cm.selection.auxillaries[cm.selection.lounge.Id] = cm.noOfPassengers;
                }

                // Normalization of options for the request
                const options = [];
                for (const auxId in cm.selection.auxillaries) {
                    const quantity = cm.selection.auxillaries[auxId];

                    if (quantity > 0) {
                        options.push({ OptionId: auxId, ChosenQuantity: quantity });
                    }
                }

                // The marhaba product in the basket is removed and added again with all the options
                basketStore.addMarhaba(marhabaSearchId, cm.selectedSecondayMarhabaOption.Id, BasketId, options).then(function() {
                    _updateBasket();
                });
            };

            cm.selectMarhaba = function(option) {
                const params = {
                    Terminal: { Id: option.TerminalId, Name: option.Terminal },
                    FlightType: option.FlightType,
                    Airport: option.Airport,
                    DateAndTime: option.Date,
                    Occupancy: { Adults: cm.occupancy.Adults, Children: cm.children, Infants: 0 }
                };
                marhabaSearch.clearSearchResults();
                basketService.getMarhaba(marhabaSearchId, BasketId, TripId, params);
            };

            cm.balancesDue = results[5];

            cm.singleOptionChanged = function() {
                addOrRemoveFlightOptionsFromBasket();
            };

            cm.multiOptionChanged = function() {
                addOrRemoveFlightOptionsFromBasket();
            };

            cm.selectSeats = function(seats) {
                cm.selectedFlightSector[0].selectedSeats = seats;
                addOrRemoveFlightOptionsFromBasket();
            };

            cm.getSelectedSeats = function() {
                return cm.selectedFlightSector[0].selectedSeats;
            };

            cm.disableContinue = function() {
                const standardConditions = (
                                            !TRPCONFIG.DeviceSettings.UseBaggageWarningPopup &&
                                            !cm.confirmedBaggageWarning &&
                                            !cm.allBaggageSelected
                                        ) || submitted;

                return standardConditions;
            };

            cm.hideContinueButton = function() {
                return TRPCONFIG.Domain.isAgentMode;
            };

            cm.disableWithAgentControl = function() {
                if ($rootScope.user.Agent && !cm.agentReadConfirm) {
                    return true;
                }
                return cm.disableContinue();
            };

            cm.validateConsent = function(consentConfirmed) {
                const isValid = !cm.hasOwnProperty('detailsStorageConsent') || consentConfirmed;
                return isValid;
            };

            cm.restructuredOptions = restructureOptionsByOptionType();


            /*Options Page redesign simplified baggage helpers  START  */
            cm.flightBaggageCosts = results[8];
            cm.bagsIncluded = 0;
            cm.bagsSelected = 0;
            cm.bagsTeaserCost = 0;
            cm.bagsWeight = 0;

            let min = {
              BagsIncludedCount: _(flight.Details.Itinerary.Legs).map(leg => leg.BagsIncludedCount).min(),
              BaggageAllowanceTotalKg: _(flight.Details.Itinerary.Legs).map(leg => leg.BaggageAllowanceTotalKg).min(),
              BaggageAllowanceKgPerBag: _(flight.Details.Itinerary.Legs).map(leg => leg.BaggageAllowanceKgPerBag).min()
            };

            cm.isBaggageInfoUnknown = min.BaggageAllowanceTotalKg === -1 && min.BagsIncludedCount === -1;

            if (min.BagsIncludedCount === 0) {
                basketStore.simplifiedBaggageCount(BasketId)
                    .then(c => {
                        if (c.price === 0 && c.maxAllowed === c.selected) {
                            //to deal with the case where the bags we have included by default are free
                            cm.bagsIncluded = c.selected;
                        } else {
                            cm.bagsTeaserCost = c.price / flight.Details.Itinerary.Legs.length;
                            cm.maxBagsSelectable = c.maxAllowed;
                            cm.bagsSelected = c.selected;
                        }
                        if (min.BaggageAllowanceKgPerBag > 0) {
                            cm.holdBagUnitWeightKg = min.BaggageAllowanceKgPerBag;
                        } else {
                            cm.holdBagUnitWeightKg = c.unitWeightKg || 20;
                        }
                    });
            } else {
                cm.bagsIncluded =
                    cm.isBaggageInfoUnknown ? null :
                    (min.BaggageAllowanceKgPerBag > 0) ? min.BagsIncludedCount :
                    (min.BaggageAllowanceTotalKg < 1) ? min.BagsIncludedCount :
                    null;

                cm.holdBagUnitWeightKg =
                    cm.isBaggageInfoUnknown ? null :
                    (min.BaggageAllowanceKgPerBag > 0) ? min.BaggageAllowanceKgPerBag :
                    (min.BaggageAllowanceTotalKg > 0) ? min.BaggageAllowanceTotalKg :
                    null;
            }

            // get hand baggage restrictions
            cm.handBaggageInformation = _getHandBaggageInformation(cm.flight.Details);

            cm.updateBaggageCount = function(popup = false) {
                analytics.track('mixpanel', popup
                    ? 'PopUpAddBagsClick'
                    : 'OptionsPageAddBagClick'
                );
                basketStore.updateBaggageOptions(BasketId, cm.bagsSelected, cm.selectedFlightSector[0].selectedMultiOptions)
                    .then(_updateBasket);
            };
            /*Options Page redesign simplified baggage helpers  END  */
        });
    }, basketService.bookingAlreadyDone(`options: '${$routeParams.tripId}'`));

    function _getHandBaggageInformation(flight) {
        const baggageInfos = flight.Itinerary.Legs.map(l => l.HandBaggageInformation)
            .filter(h => h != null);

        const getMin = prop => {
            const relevant = _.filter(baggageInfos, info => {
                return info[prop] > 0;
            });

            const min = _.min(_.flatMap(relevant, r => r[prop]));

            return min || 0;
        };

        return {
            PiecesAllowed: getMin('PiecesAllowed'),
            WidthCm: getMin('WidthCm'),
            HeightCm: getMin('HeightCm'),
            DepthCm: getMin('DepthCm'),
            WeightKg: getMin('WeightKg')
        };
    }

    function checkOptions(options) {
        let errors = [];
        if (options.length > 0) {
            errors = options.map(option => {
                return checkRequiredOption(option);
            }).filter(reqOption => {
                    return reqOption.error === true;
            });
        }

        return { errors };
    }

    function checkRequiredOption(option) {
        let error = false;
        let requiredOption = { error };
        switch (option.toLowerCase()) {
            case OPTION_TRANSFER:
                error = (TRPCONFIG.Domain.EnforceTransferOptionSelection
                    && cm.selectedTransfer == null);
                if (error) {
                    _.assign(requiredOption, { error }, { title: option, id: 'transfer-selection', offset: 0 });
                }
            break;

            case OPTION_PARKING:
                error = (TRPCONFIG.Domain.AirportParkingEnabled
                    && TRPCONFIG.Domain.EnforceParkingOptionSelection
                    && cm.selectedParking == null);
                    if (error) {
                        _.assign(requiredOption, { error }, { title: option, id: 'parking-selection', offset: 200 });
                    }
            break;
        }

        return requiredOption;
    }

    function _updateBasket() {
        return basketService.updateBasket();
    }

    function _setQuantitative(extra, parentIndex, index, selected) {
        const uniqueOptionExists = arrayUtil.any(extra.Options, function(option) {
            return option.Key.OptionId !== extra.Options[0].Key.OptionId;
        });

        if (!uniqueOptionExists) {
            if (!selected.multiOptionsQuantity) {
                selected.multiOptionsQuantity = [];
            }
            if (!selected.multiOptionsQuantity[parentIndex]) {
                selected.multiOptionsQuantity[parentIndex] = {};
            }

            if (selected.selectedMultiOptions && selected.selectedMultiOptions[parentIndex] && selected.selectedMultiOptions[parentIndex][index] && selected.selectedMultiOptions[parentIndex][index].Quantity) {
                selected.multiOptionsQuantity[parentIndex][index] = selected.selectedMultiOptions[parentIndex][index].Quantity;
            } else {
                selected.multiOptionsQuantity[parentIndex][index] = 0;
            }

            // remove options with quantity set to 0
            extra.Options = extra.Options.filter(op => op.Quantity);
            extra.Quantitative = true;
        }
    }

    //this accepts a source options array and a destination options array and a
    //function into which to pass the items that are in src and missing from
    //dest. The function must accept an array of options and return a promise.
    function _missingFrom(src, dst, forall) {
        return forall(arrayUtil.map(arrayUtil.filter(src, function(o1) {
            return !arrayUtil.any(dst, function(o2) {
                return angular.equals(o1, o2);
            });
        }), function(optionKey) {
            return { OptionId: optionKey.OptionId, ChosenQuantity: optionKey.Quantity };
        }));
    }

    function _updateCostBreakdown(basketId) {
        return () => {
            const { productId } = $routeParams;

            return $q.all([
                basketStore.costBreakdown(basketId, productId),
                basketStore.totalDeposit(basketId, productId),
                basketStore.totalCost(basketId),
                basketStore.flightBaggageCostings(basketId),
                basketStore.payDirectTotal(basketId),
                basketStore.payments(basketId)
            ]).then(res => {
                cm.costBreakdown = res[0];
                cm.totalDeposit = res[1];
                cm.totalCost = res[2];
                cm.flightBaggageCosts = res[3];
                cm.payDirectAmount = res[4];
                cm.paymentData = res[5];
                basketStore.getBaseCost(res);
                if (!sessionStorage.getItem('baseCost')) {
                    sessionStorage.setItem('baseCost', basketStore.getBaseCost(res));
                }
            });
        };
    }

    function _updateBagInfo(trip) {
        baggageService.getBaggageInfo(trip.TripId).then(bagInfo => {
            const people = occupancyService.getNumberOfNonInfantPassengers() || 1;
            _.forEach(cm.selectedFlightSector, (sector, index) => {
                sector.bagInfo = bagInfo[index];
                sector.bagInfo.allBaggageSelected = sector.bagInfo.holdBagsIncluded || sector.bagInfo.passengerHoldBags.length === people;
            });
            cm.allBaggageSelected = _.every(cm.selectedFlightSector, sector => sector.bagInfo.allBaggageSelected);
        });
    }

    function _updateDepositValues(basketId) {
        return $q.all([
            basketStore.all(basketId),
            basketStore.balancesDue(basketId),
            basketStore.rules(basketId)
        ]).then(([{ h, f, t }, balancesDue, basketRules]) => {
            cm.hotel = h;
            cm.flight = f;
            cm.transfer = t;
            cm.balancesDue = balancesDue;
            cm.basketRules = basketRules;
        });
    }

    function _mergeSelectedOptions() {
        const opts = [];
        angular.forEach(cm.selectedFlightSector, _mergeSelectedOptionsInternal);
        return opts;

        function _mergeSelectedOptionsInternal(model) {
            angular.forEach(model.selectedOptions, o => opts.push(o));
            angular.forEach(model.selectedMultiOptions, function(grp) {
                angular.forEach(grp, function(o) {
                    if (o != null) {
                        opts.push(o);
                    }
                });
            });
            angular.forEach(model.selectedSeats, function(s) {
                opts.push(s);
            });
        }
    }

    function _extractAirportsFromLeg(leg) {
        const validAirports = [];
        let a;
        a = _filterAirportObject(leg.ArrivalAirport, 'ARRIVAL');
        a.Date = leg.ArrivalDate;
        a.FlightType = { Id: 1, Name: resourceService.get('ARRIVAL'), Label: resourceService.get('ORIGIN') };
        a.TerminalId = _sanitizeTerminal(leg.Segments[leg.Segments.length - 1].DestinationTerminal);
        a.FullTitle = `${a.Title} - Terminal ${a.TerminalId}`;
        validAirports.push(a);

        a = _filterAirportObject(leg.DepartureAirport, 'DEPARTURE');
        a.Date = leg.DepartureDate;
        a.FlightType = { Id: 2, Name: resourceService.get('DEPARTURE'), Label: resourceService.get('DESTINATION') };
        a.TerminalId = _sanitizeTerminal(leg.Segments[0].DepartureTerminal);
        a.FullTitle = `${a.Title} - Terminal ${a.TerminalId}`;
        validAirports.push(a);

        return validAirports;
    }

    function _sanitizeTerminal(terminal) {
        if (!terminal) {
            return 1;
        }

        const terminalId = parseInt(terminal);
        if (isNaN(terminalId)) {
            return 1;
        }
        return terminalId;
    }

    function _filterAirportObject(airport, type) {
        return {
            Title: airport.Title,
            Airport: { Title: airport.Title, Code: airport.Code },
            Type: resourceService.get(type)
        };
    }

    function _buildMarhabaOptions(flight) {
        const itinerary = flight.Details.Itinerary;
        const m = _.flatMap(itinerary.Legs, _extractAirportsFromLeg);
        const codes = _.uniq(m.map(a => a.Airport.Code));

        // ...find out marhaba enabled terminals related to the selected airports...
        cm.marhabaOptions = [];
        marhabaService.getMarhabaEnabledTerminals(codes)
        .then(function(res) {
            // ...ignore non-enabled airports.
            for (let i = m.length - 1; i >= 0; i--) {
                const option = m[i];
                const validTerminals = res.data.AirportsTerminals[option.Airport.Code];

                let marhabaEnabled = false;
                if (!validTerminals) {
                    continue;
                }

                if (validTerminals.length === 1) {
                    option.TerminalId = validTerminals[0].Id;
                    option.Terminal = validTerminals[0].Name;
                    option.TerminalNumber = validTerminals[0].TerminalNumber;
                    marhabaEnabled = true;
                } else {
                    for (let j = validTerminals.length - 1; j >= 0; j--) {
                        if (option.TerminalId === parseInt(validTerminals[j].Id)) {
                            option.Terminal = validTerminals[j].Name;
                            option.TerminalNumber = validTerminals[j].TerminalNumber;
                            marhabaEnabled = true;
                            break;
                        }
                    }
                }

                if (marhabaEnabled) {
                    cm.marhabaOptions.push(option);
                }
            }
        });
    }

    function isCarHireTemporaryDisabled() {
        if (cm.flight && cm.flight.Details.Itinerary) {
            const aiportCode = cm.flight.Details.Itinerary.Legs[0].ArrivalAirport.Code;
            if (TRPCONFIG.Domain.IsCarHireTemporaryDisabled.indexOf(aiportCode) > -1) {
                cm.carHireTemporaryDisabled = true;
            }
        }
    }

    $timeout(function() {
        $anchorScroll();
    });

    cm.updateQuantitativeOption = function(parent, index, quantity, options, selected) {
        if (options && selected.selectedMultiOptions) {
            const option = (arrayUtil.first(options, function(op) {
                return op.Key.Quantity === quantity;
            }));
            selected.selectedMultiOptions[parent][index] = option ? {
                OptionId: option.Key.OptionId,
                Quantity: option.Key.Quantity
            } : null;
        }
        cm.multiOptionChanged();
    };

    cm.quantitativeOptionTotalPrice = function(key, options) {
        if (key && options) {
            return arrayUtil.first(options, function(op) {
                return angular.equals(op.Key, key);
            }).TotalAmountString;
        }
    };

    /* start desktop */
    cm.isBaggageOptionInTheHold = function(option, sector) {
        if (!sector || !sector.bagInfo || !option) {
            return false;
        }
        const showCheckbox = sector.bagInfo.passengerHoldBags.filter(function(value) {
            return value.Id === option.OptionId;
        });
        return showCheckbox.length > 0;
    };

    cm.showPopupBaggage = false;
    cm.popupBaggageNotRequired = function() {
        cm.confirmedBaggageWarning = true;
        cm.book();
    };

    cm.scrollToExtraOptions = function() {
        scrollService.scrollTo('[optional-extras-scroll-target]', { animate: true });
    };

    cm.changeHotel = function() {
        basketService.changeJourneyUrl(20);
    };

    analytics.track('mixpanel', 'OptionsPage');
    /* end desktop */

    function restructureOptionsByOptionType() {
        const optionGroups = {};
        if (cm.flight && cm.flight.Details && cm.flight.Details.FlightSectorOptionalExtras) {
            const isTwoWayFlight = cm.flight.Details.FlightSectorOptionalExtras.length === 2;

            _.forEach(cm.flight.Details.FlightSectorOptionalExtras, (sector, sectorIndex) => {
                _.forEach(sector.NonCheckInOptions, (option, parentIndex) => {
                    let sectorLegType = null;
                    if (isTwoWayFlight) {
                        sectorLegType = sectorIndex === 0 ? 'outbound' : 'inbound';
                    }

                    if (!optionGroups[option.Title]) {
                        optionGroups[option.Title] = [];
                        optionGroups[option.Title].hideOptions = option.Type !== 0;
                    }

                    optionGroups[option.Title].push({
                        grp: option,
                        selected: cm.selectedFlightSector[sectorIndex],
                        parentIndex,
                        SectorDescription: sector.Description,
                        sectorLegType
                    });
                });
            });
        }
        return optionGroups;
    }

    cm.updateChauffeurNum = function() {
        cm.selection.chauffeur.Num = 1;
    };

    cm.getMarhabaHeading = function(p) {

        const value = p.Type ? p.Type : parseInt(p);
        switch (value) {
            case 1:
                return resourceService.get('MEETANDGREET');
            case 5:
                return resourceService.get('LOUNGES');
            case 2:
                return resourceService.get('TRANSFERS');
        }
        return '';
    };

    cm.viewMarhabaInfo = function(marhabaId, $event) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        cm.currentMarhabaInfoId = marhabaId;
    };

    cm.noMarhabaOption = '';
    if (TRPCONFIG.Domain.MarhabaDefaultSelected) {
        cm.selectedMarhabaOption = cm.noMarhabaOption;
    }

    $scope.$watch('cm.selectedMarhabaOption', function(val) {
        cm.loadingMarhaba = true;
        cm.secondaryMarhabaOptions = null;
        cm.filteredMarhabaOptions = null;
        cm.selection = { auxillaries: {} };
        cm.auxillaryProducts = [];
        cm.chauffeurs = [];
        cm.lounges = [];
        cm.additionalMarhabaOptions = null;
        if (!_.isUndefined(val) && cm.removeMarhaba) {
            cm.removeMarhaba();
        }
        if (!val) {
            cm.loadingMarhaba = false;
            return;
        }
        cm.getSecondaryMarhabaOptions(val).then(function(data) {
            if (data && data.MarhabaQuotes && data.MarhabaQuotes.length > 0) {
                data.MarhabaQuotes = data.MarhabaQuotes
                    .sort(marhabaService.sort)
                    .filter(marhabaService.filter)
                    .map((item, idx, arr) => {
                        const prev = arr[idx - 1];
                        item.showHeading = !prev || (prev && prev.Type !== item.Type);
                        item.isLounge = item.Type === 5;
                        item.isTransfer = item.Type === 2;
                        return item;
                });
            } else {
                cm.noServices = true;
            }

            cm.secondaryMarhabaOptions = data;
            cm.filteredMarhabaOptions = _.groupBy(data.MarhabaQuotes, 'Type');
            cm.loadingMarhaba = false;
        });
    });

    $scope.$watch('cm.selectedSecondayMarhabaOption', function(val) {
        cm.loadingMarhaba = true;
        cm.selection = { auxillaries: {} };
        cm.auxillaryProducts = [];
        cm.chauffeurs = [];
        cm.lounges = [];
        cm.additionalMarhabaOptions = null;
        if (val == null) {
            cm.loadingMarhaba = false;
            return;
        }
        cm.addMarhabaToBasket();
    });

    /* Config for AbTest of the probability system for options */
    const cancel = $scope.$watch('cm.abTestProbability', function(v) {
        if (!v) {
            return;
        }
        cancel();
        if (v === true) {
            tripService.getTrip($routeParams.tripId).then(function(trip) {
                const products = [enumService.ProductType.Transfer, enumService.ProductType.CarHire];
                crossSellService.getCrossSellProbability(trip.BasketId, products)
                    .then(function(p) {
                        cm.TransferCrossSellExpand = (p[enumService.ProductType.Transfer] >= 0.5);
                        cm.CarHireCrossSellExpand = (p[enumService.ProductType.CarHire] >= 0.5);
                    });
            });
        }
    });

    cm.bagsPopupButtonText = () => {
        return resourceService.get(cm.bagsSelected
            ? 'POPUPCONFIRMBAGSADDED'
            : 'POPUPCONFIRMNOBAGS');
    };

    cm.isHFareFlightType = () => {
        return flightDetail.isHFlightType(_.get(cm.flight, 'Details.Itinerary'), false);
    };
}
})();
